import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';
import confirmModalModule from '../../../../../lib/components/modals/confirmModal'

// Translations
import translateModuleName from '../../../../../lib/translation';

// Controller
import AddPhotosModalController from './addPhotosModal.controller';
import template from './addPhotosModal.html';

const moduleName = 'staff.dashboardScreen.addPhotosModal';
let module = angular.module(moduleName, [
  uiModal,
  confirmModalModule.name,
  translateModuleName,
]);

module.controller('AddPhotosModalController', AddPhotosModalController);

module.factory('addPhotosModal', ['$uibModal', '$q', ($uibModal, $q) => {
  return props => {

    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: AddPhotosModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        position: props.position
      }
    });
    return modal.result;
  };
}]);

export default module;

